import { useAuth0 } from '@auth0/auth0-react'
import { Select } from '@cimpress/react-components'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { SnackbarController } from '../../../common/components/SnackbarController'
import * as models from '../../../common/models'
import { addLocationToNetwork } from '../../../common/proxy/locations-store'
import AwaitingModal from '../../../calendars/components/AwaitingModal'
import * as LocationContext from './LocationsContext'

interface Props {
  location?: models.Location
  onCloseModal: () => void
}

export function AddLocationToNetworkModal(props: Props) {
  const { getAccessTokenSilently } = useAuth0()
  const [selectedNetwork, setSelectedNetwork] = React.useState<string>()
  const { t } = useTranslation()
  const { reloadLocations, networks } = React.useContext(
    LocationContext.Context
  )

  const selectNetwork = (data: models.Option) => {
    setSelectedNetwork(data.value as string)
  }

  const onClickAddToNetwork = async () => {
    try {
      const accessToken = await getAccessTokenSilently()
      await addLocationToNetwork(
        accessToken,
        props.location!.id,
        selectedNetwork!
      )
      await reloadLocations()
    } catch (error) {
      SnackbarController.show(
        t(
          'locations.selectLocationPage.addLocationToNetworkModal.errorAddingToNetwork'
        ),
        'danger'
      )
    }
  }

  const footer = [
    {
      handler: props.onCloseModal,
      text: t('common.cancel'),
    },
    {
      type: 'primary',
      handler: onClickAddToNetwork,
      text: t('locations.selectLocationPage.addToNetwork'),
      savingText: t(
        'locations.selectLocationPage.addLocationToNetworkModal.addingToNetwork'
      ),
    },
  ]

  const networkOptions = networks
    .filter(network => network.editable)
    .map(network => ({
      label: network.apiNetwork.name,
      value: network.apiNetwork.id,
    }))

  return (
    <AwaitingModal
      title={t('locations.selectLocationPage.addLocationToNetworkModal.title', {
        location: props.location ? props.location.name : '',
      })}
      show={props.location !== undefined}
      closeButton={true}
      onRequestHide={props.onCloseModal}
      footer={footer}
    >
      <h5>
        {t('locations.selectLocationPage.addLocationToNetworkModal.network')}
      </h5>
      <Select
        label={t(
          'locations.selectLocationPage.addLocationToNetworkModal.selectANetwork'
        )}
        isSearchable={true}
        isClearable={false}
        name={'addToNetwork'}
        value={networkOptions.filter(o => o.value === selectedNetwork)}
        options={networkOptions}
        onChange={selectNetwork}
        menuPortalTarget={document.getElementById(models.reactSelectPortalId)}
      />
    </AwaitingModal>
  )
}
